import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import {
  HORIZONTAL_AUDIO_PLAYER,
  EMAIL,
  EmailDefinition,
  IMAGE,
  ImageDefinition,
  LayoutColumnsDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  QUIZ_CHOICE,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const SocialMedia6: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  //

  const getMediaUrl = () => {
    const sequenceAudios = sequence?.items
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ?.map(item => item?.audios)
      ?.filter(audios => Boolean(audios));

    return sequenceAudios?.length ? sequenceAudios[0][0]?.mediaUrl : null;
  };

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Email':
        columns.items.push({
          type: EMAIL,
          id: item.id,
          values: {
            from: 'username@email.com',
            subject: 'Marco’s medical record'
          },
          items: [
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body?.replace(
                  '[user]',
                  item.title ? item.title : ''
                ),
                variant: 'text'
              }
            },
            ...(item?.pictures?.map(
              image =>
                ({
                  type: IMAGE,
                  id: image.id,
                  items: [],
                  values: {
                    url: image.mediaUrl || undefined,
                    alt: image.name
                  }
                } as ImageDefinition)
            ) || []),
            ...(item?.audios?.map(audio => ({
              type: HORIZONTAL_AUDIO_PLAYER,
              id: audio.id,
              items: [],
              values: {
                autoPlay: true,
                mediaUrl: audio.mediaUrl,
                name: audio.name,
                subtitlesUrl: audio.subtitlesUrl
              }
            })) || [])
          ]
        } as EmailDefinition);
        break;
      case 'Question':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle || 'QUIZ',
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            },
            {
              type: QUIZ_CHOICE,
              id: item.id,
              values: {
                variant: item.items && item.items.length > 2 ? 'list' : '',
                title: item?.title?.includes('?')
                  ? item.title
                  : item?.body?.includes('?')
                  ? item.body
                  : '',
                length: item?.items?.length,
                multiSelect: item?.items?.filter(item => item.correct === true)
                  .length
              },
              items: AnswerButtonHelper({
                group: item.id,
                items: item.items,
                linkedAudioId: getMediaUrl(),
                llamaSurvey: item.llamaSurvey,
                question: item.title || ''
              })
            }
          ]
        });
        break;
      case 'Text':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle || 'QUIZ',
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            }
          ]
        });
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
